import { useCallback, useMemo, useState } from 'react'

import {
  BulkSelection,
  ExportCertificatesHandlers,
} from 'modules/trainings/components/Revamp/TrainingsDetail/ParticipantsOneDataTable/hooks/useBulkActionsConfig'

import { useDirectCertificateDownload } from './useDirectCertificateDownload'

export const useExportCertificatesModal = (trainingId: number) => {
  const [isOpen, setIsOpen] = useState(false)
  const [selectedParticipantIds, setSelectedParticipantIds] = useState<number[]>([])

  const { downloadCertificatesForSelection } = useDirectCertificateDownload({ trainingId })

  const open = useCallback((participantIds: number[] = []) => {
    setSelectedParticipantIds(participantIds)
    setIsOpen(true)
  }, [])

  const close = useCallback(() => {
    setIsOpen(false)
    setSelectedParticipantIds([])
  }, [])

  const handleSelectAllExport = useCallback(
    async (selection: BulkSelection) => {
      await downloadCertificatesForSelection(selection)
    },
    [downloadCertificatesForSelection]
  )

  const exportCertificatesHandlers: ExportCertificatesHandlers = useMemo(
    () => ({
      onSelectAllExport: handleSelectAllExport,
      onManualExport: open,
    }),
    [handleSelectAllExport, open]
  )

  return {
    isOpen,
    selectedParticipantIds,
    open,
    close,
    exportCertificatesHandlers,
  }
}
